module.exports = __webpack_public_path__ + "img/33000.7016a318.jpg";